import { useRef, useCallback } from 'react';
export function useClickDouble(onSingle, onDouble, delay = 230) {
    const t = useRef(null);
    return useCallback((e) => {
        e.stopPropagation();
        if (t.current) {
            clearTimeout(t.current);
            t.current = null;
            onDouble(e);
        }
        else {
            t.current = setTimeout(() => {
                t.current = null;
                onSingle(e);
            }, delay);
        }
    }, [onSingle, onDouble, delay]);
}
